export const getUrlParams = (state: any) => state?.commonReducer?.urlParams;

export const reloadMenuCountDataSelector = (state: any) =>
  state?.commonDataReducer?.reloadMenuCountData;

export const menuCountDataSelector = (state: any) =>
  state?.commonDataReducer?.menuCountData;
